<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4">
                                    <figure>
                                        <img :src="robot.image" class="w-100" alt="">
                                    </figure>
                                </div>
                                <div class="col-lg-8">
                                    <h3 class="fw-bold">{{robot.name}}</h3>

                                    <div class="row">
                                        <div class="col-6">
                                            <p class="title">Risk Level</p>
                                            <h5 class="text">
                                                <span v-if="robot.risk_level == 3" class="badge badge-danger">HIGH</span>
                                                <span v-else-if="robot.risk_level == 2" class="badge badge-warning">MEDIUM</span>
                                                <span v-else-if="robot.risk_level == 1" class="badge badge-success">LOW</span>
                                                <span v-else>-</span>
                                            </h5>
                                        </div>
                                        <!-- <div class="col-6">
                                            <p class="title">Trade Report</p>
                                            <p class="text">
                                                <a :href="robot.trade_report_file" target="_blank">
                                                    <i class="fas fa-file" v-if="robot.trade_report_file !== null"></i><span v-else>-</span>
                                                </a>
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Strategy</p>
                                            <p class="text" v-html="robot.strategy ? robot.strategy : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Description</p>
                                            <p class="text" v-html="robot.description ? robot.description : '-'">
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Type</p>
                                            <p class="text">
                                                {{robot.type ? robot.type : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Lot Size</p>
                                            <p>
                                                <span class="badge bg-dark me-1">{{local_lotSize ?`${local_lotSize}%`: '-'}}</span>
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Active Pair</p>
                                            <div v-if="active_pairs.length >= 1" class="col-start-1 d-flex gap-2" >
                                                <p >
                                                    {{local_active_pairs? local_active_pairs : '-'}}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Recommended Pair Option</p>
                                            <p v-if="pair_options.length >= 1">
                                                <span v-for="(pair, index) in local_pair_options" :key="index" class="badge bg-dark me-1">    
                                                    {{pair? pair : '-'}}
                                                </span>
                                            </p>
                                            <p v-else>
                                                <span class="badge bg-dark me-1">'-'</span>
                                            </p>
                                        </div>
                                         <div class="col-12">
                                            <p class="title fw-bold mb-0">Robot Price</p>
                                            <p class="text" v-if="robot.selling_price">
                                                Rp {{new Intl.NumberFormat('id-ID').format(Number(parseInt(robot.selling_price)).toFixed())}}
                                            </p>
                                            <p class="text badge badge-danger" v-else-if="!robot.selling_price">
                                               Gagal memuat
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title fw-bold mb-0">Artkey Price</p>
                                            <p class="text" v-if="artKey">
                                                Rp {{new Intl.NumberFormat('id-ID').format(Number(parseInt(artKey)).toFixed())}}
                                            </p>
                                            <p class="text badge badge-danger" v-else-if="!artKey">
                                                Gagal memuat
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title">
                                                Last updated at : <span class="badge badge-light">{{robot.updated_at | moment}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="broker">
                                        <h5 class="mb-3 fw-bold">Choose Broker</h5>
                                        <div class="row">
                                            <div class="col-lg-3" v-for="broker in filterBrokers" :key="broker.id">
                                                <div class="broker-list">
                                                    <input type="radio" name="broker" @click="sendBroker(broker)" :id="'broker'+broker.id">
                                                    <label :for="'broker'+broker.id" class="broker-body">
                                                        <!-- <div class="broker-body"> -->
                                                            <div class="check_img">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 35.294 35.294">
                                                                    <g id="check_icon" transform="translate(-440 -366)">
                                                                        <path id="Path_395" data-name="Path 395" d="M8.585,0H26.709a8.585,8.585,0,0,1,8.585,8.585V26.709a8.585,8.585,0,0,1-8.585,8.585H8.585A8.585,8.585,0,0,1,0,26.709V8.585A8.585,8.585,0,0,1,8.585,0Z" transform="translate(440 366)" fill="#ed1c24"/>
                                                                        <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M6.588,18.758l-6.3-6.3a.97.97,0,0,1,0-1.372L1.656,9.711a.97.97,0,0,1,1.372,0l4.247,4.247,9.1-9.1a.97.97,0,0,1,1.372,0l1.372,1.372a.97.97,0,0,1,0,1.372L7.96,18.758A.97.97,0,0,1,6.588,18.758Z" transform="translate(447.631 371.916)" fill="#fff"/>
                                                                    </g>
                                                                </svg>
                                                            </div>
                                                            <figure>
                                                                <img :src="broker.logo" :class="(broker.country == 'Indonesia' && user.identity_type == 'ID_CARD') || (broker.country == 'Indonesia' && user.identity_type == 'DRIVING_LICENSE')  || user.identity_type == 'PASSPORT' ? 'aliveimg' : ''" class="broker-img" alt="">
                                                            </figure>
                                                            <p class="text-center">{{broker.name}}</p>
                                                            <button type="button" class="linkbroker" data-toggle="modal" data-target="#modalBroker" @click="brokerdetail(broker)" ><u>Detail</u></button>
                                                            <div class="modal fade" id="modalBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                                                <div class="modal-dialog modal-dialog-centered">
                                                                    <div class="modal-content">
                                                                        <div class="modal-body modalbroker">
                                                                            <div>
                                                                                <h3>Detail Broker</h3>
                                                                                <!-- <span class="badge badge-danger">Reccomended </span> -->
                                                                                <div class="d-flex headdetailbroker mt-1">
                                                                                    <figure>
                                                                                        <img :src="brokerdata.logo" alt="">
                                                                                    </figure>
                                                                                    <div class="deskripsi-head">
                                                                                        <small>
                                                                                            {{brokerdata.company_name}}
                                                                                        </small>
                                                                                        <h5>{{brokerdata.name}}</h5>
                                                                                        <p>{{brokerdata.type}} | {{brokerdata.country}}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <h6 class="mt-3">
                                                                                    Telephone
                                                                                </h6>
                                                                                <p class="pl-2">{{brokerdata.phone}}</p>
                                                                                <h6 class="mt-2">
                                                                                    Email
                                                                                </h6>
                                                                                <p class="pl-2">{{brokerdata.email}}</p>
                                                                                <h6 class="mt-2">
                                                                                    Deskripsi
                                                                                </h6>
                                                                                <div class="pl-2" v-if="brokerdata.description" v-html="brokerdata.description"></div>
                                                                                <div class="pl-2" v-if="!brokerdata.description" >-</div>
                                                                            </div>
                                                                            <div class="bottommodal">
                                                                                <small>Regulated by bappebti</small>
                                                                                <button type="button" class="btn btn_grey" data-dismiss="modal" >Close</button>
                                                                                <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                                                                <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        <!-- </div> -->
                                                    </label>
                                                </div>
                                            </div>
                                            <p v-if="filterBrokers.length == 0">No Broker available.</p>
                                        </div>
                                        <!-- <div class="row">
                                            <div class="col-lg-3" v-for="broker in brokers" :key="broker.id">
                                                <router-link :to="'detail/'+broker.id" class="broker-list">
                                                    <div class="broker-body">
                                                        <figure>
                                                            <img :src="broker.logo" class="broker-img" alt="">
                                                        </figure>
                                                        <p class="text-center">{{broker.name}}</p>
                                                    </div>
                                                </router-link>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="">
                                        <button type="button" :disabled="filterBrokers.length == 0" @click="clickmodal()" class="btn btn_red my-2" data-toggle="modal" data-target="#chooseBroker">Continue</button>
                                    </div>

                                    <div class="modal fade" id="chooseBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button> -->
                                                    <div v-if="message && !$v.$invalid" class="alert alert-danger">
                                                        {{message.message}}
                                                    </div>
                                                    <div class="text-center" v-if="brokerName">
                                                        <h3 class="title">{{brokerName}}</h3>
                                                        <p>Are you sure to choose this Broker?</p>
                                                    </div>
                                                    <div class="text-center" v-else>
                                                        <h3 class="title">Ooppss...</h3>
                                                        <p>Looks like you haven't chosen a broker</p>
                                                    </div>

                                                    <!-- <form @submit.prevent="handleProduct()"> -->
                                                        <!-- <input type="hidden" v-model="product.investor_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.broker_account_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.product_id" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.product_type" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.payment_amount" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.currency" class="form-control" readonly >
                                                        <input type="hidden" v-model="product.status" class="form-control" readonly > -->
                                                        <div class="row">
                                                            <div class="col-lg-6 mx-auto">
                                                                <div class="text-center button d-flex align-items-center justify-content-center">
                                                                    <button type="button" class="btn btn_grey m-2" data-dismiss="modal" v-if="brokerName">No</button>
                                                                    <button type="button" class="btn btn_outline_red m-2" data-dismiss="modal" v-else>Back</button>
                                                                    <button type="submit" v-if="brokerName" @click="completeBroker()" class="btn btn_red">Yes, I'm sure</button>
                                                                    <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                                                    <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    <!-- </form> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal fade" id="detailBroker" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-scrollable">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button> -->
                                                    <div class="text-center">
                                                        <h3 class="title">Trading Account Details</h3>
                                                        <p>Please complete this form to continue!</p>
                                                    </div>

                                                    <div class="broker_info">
                                                        <h6 class="broker_title">Broker you choose:</h6>
                                                        <div class="broker_data">
                                                            <img :src="brokerImage" :alt="brokerImage">
                                                            <p>{{brokerName}}</p>
                                                        </div>
                                                    </div>

                                                    <form class="mx-4">
                                                    <div class="form-group">
                                                        <!-- <div v-if="message.data.account_number.length > 0 || message.data.trader_password.length > 0 || message.data.broker_server.length > 0 || message.data.deposit_amount.length > 0" class="alert alert-danger" role="alert">{{message.message}}</div> -->
                                                    </div>
                                                        <div class="form-group">
                                                            <div class="input">
                                                                <!-- <input type="hidden" v-model="brokerId" v-validate="'required'" name="password" class="form-control field-password" placeholder="Account Number"> -->
                                                                <input type="tel" v-on:keypress="NumbersOnly" v-model="account_number" v-validate="'required'" name="account_number" class="form-control" :class="{ 'is-invalid':$v.account_number.$error}" placeholder="Account number">
                                                                
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-if="$v.account_number.$error"
                                                                >
                                                                <small>Account Number Required</small>
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-else-if="dataAccountNumber > 0"
                                                                >
                                                                <small>{{message.data.account_number[0]}}</small>
                                                            </div>
                                                            
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="input">
                                                                <input type="text" v-model="trader_password" autocomplete="off" v-validate="'required'" name="password" class="form-control field-password" :class="{ 'is-invalid':$v.trader_password.$error }" placeholder="Your trading password">
                                                                <!-- <div class="input-group-append show_pass">
                                                                    <span class="input-group-text"><i @click="showPassword" class="eye-icon bi bi-eye"></i></span>
                                                                </div> -->
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-if="$v.trader_password.$error"
                                                                >
                                                                <small>Trader Password Required</small>
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-else-if="dataTradePassword > 0"
                                                                >
                                                                <small>{{message.data.trader_password[0]}}</small>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="input">
                                                                <input type="text" v-model="broker_server" v-validate="'required'" name="broker_server" class="form-control" :class="{ 'is-invalid':$v.broker_server.$error }" placeholder="Broker server">
                                                                
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-if="$v.broker_server.$error"
                                                                >
                                                                <small>Broker Server Required</small>
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-else-if="dataBrokerServer > 0"
                                                                >
                                                                <small>{{message.data.broker_server[0]}}</small>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="input-group mb-3">
                                                                <span class="input-group-text">$</span>
                                                                <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model="deposit_amount" v-validate="'required'" name="deposit_amount" class="form-control" :class="{ 'is-invalid':$v.deposit_amount.$error }" aria-label="Amount (to the nearest dollar)" placeholder="Deposit Amount">
                                                                <!-- <span class="input-group-text">.00</span> -->
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-if="$v.deposit_amount.$error"
                                                                >
                                                                <small>Deposit Amount Required</small>
                                                            </div>
                                                            <div
                                                                class="text-danger"
                                                                v-else-if="dataDepositAmount > 0"
                                                                >
                                                                <small>{{message.data.broker_server[0]}}</small>
                                                            </div>
                                                            <!-- <div v-if="submitted && errors.has('deposit_amount')" class="text-danger">
                                                                {{errors.first('deposit_amount')?'Deposit Amount is Required':''}}
                                                            </div> -->
                                                            <!-- <div v-else-if="submitted && msg.data.deposit_amount" class="text-danger">
                                                                {{msg.data.deposit_amount[0]}}
                                                            </div> -->
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-12 mx-auto">
                                                                <div>
                                                                    <!-- <button type="button" class="btn btn_outline_red m-2" data-dismiss="modal" v-else>Back</button> -->
                                                                   
                                                                    <button type="button" v-if="brokerName" class="btn btn-danger w-100 px-5" @click="handleProduct()" :disabled="loading || submitted">
                                                                        <span v-if="loading || submitted" class="spinner-border spinner-border-sm"></span>
                                                                        <span v-else-if="!loading && !submitted">Save account detail</span>
                                                                    </button>
                                                                    <button type="button" class="btn btn-secondary mt-2 w-100" data-dismiss="modal" v-if="brokerName">Cancel</button>
                                                                   <div v-if="brokerEndPoint.length > 0">
                                                                     <h6 class="w-100 text-center mt-3">or</h6>
                                                                    <small class="w-100 text-center small-if">If you don't have broker account please sign up</small>
                                                                     <a :href="brokerEndPoint[0].endpoint" class="btn btn-outline-danger w-100 m-2" target="_blank" rel="noopener noreferrer">Sign Up</a>
                                                                   </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dash-footer></dash-footer>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import $ from 'jquery'
import moment from "moment";
import {required } from "vuelidate/lib/validators";
import swal from 'sweetalert'

export default {
    name: "AllRobot",
    components: {
        DashHeader,
        DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            robot: [],
            user: [],
            brokers:[],
            brokerdata:[],
            details:[],
            brokerId: '',
            brokerEndPoint: [],
            brokerName: '',
            artKey: '',
            brokerImage: '',
            account_number : '',
            trader_password : '',
            broker_server : '',
            deposit_amount : '',
            order: [],
            transaction: [],
            submitted: false,
            loading: true,
            active_pairs: [],
            local_lotSize: [],
            local_active_pairs: [],
            pair_options: [],
            local_pair_options: [],
            lotSizes: [],
            message: {
                data:{
                    broker_id:[],
                    account_number : [],
                    trader_password : [],
                    broker_server : [],
                    deposit_amount : [],
                }
            },
            msg: '',
            product: {
                investor_id : '',
                broker_account_id : '',
                product_id : '',
                product_type : '',
                payment_amount : '',
                deposit_amount : '',
                currency : '',
                status : '',
            }
        }
    },
    validations: {
      deposit_amount: {
        required,
      },
      account_number: {
        required,
      },
      trader_password: {
        required,
      },
      broker_server: {
        required,
      },
  },
    computed: {
        filterBrokers(){
            return this.brokers.filter(item => item.is_active == true)
        },
        dataloading(){
            return this.loading
        },
        dataAccountNumber(){
            return this.message?.data?.account_number?.length
        },
        dataTradePassword(){
            return this.message?.data?.trader_password?.length
        },
        dataDepositAmount(){
            return this.message?.data?.deposit_amount?.length
        },
        dataBrokerServer(){
            return this.message?.data?.broker_server?.length
        },
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        }
    },
    async mounted(){
        window.scrollTo(0,0)
        
        this.local_lotSize = localStorage.getItem('lotSize');
        this.local_active_pairs = localStorage.getItem('activePair');

        // store the pair options data in array
        let localVar = localStorage.getItem('pairOption').replace(/[()]/g, '')
        let arr = localVar.split(', ').map(item => item.trim());
        this.local_pair_options = arr;

        await axios.get(`investor/${localStorage.user_id}`)
            .then(response => {
                // console.log('Profile: ', response.data.data)
                this.user = response.data.data
            }).catch((err) => {
                console.log('Error Profile: ', err)
            })
        await axios.get(`investor/robot/${this.$route.params.id}`)
        .then(response => {
            // console.log('Robot All: ', response.data.data)
            this.robot = response.data.data
            this.details = this.robot.strategy;
            // this.details = this.robot.strategy.split(';');
            this.active_pairs = this.robot.active_pairs.map(pair => pair)
            this.pair_options = this.robot.pair_options.map(pair => pair)
            this.lotSizes = this.robot.lot_sizes.map(pair => pair)
        }).catch(() => {
            // console.log('Error Robot: ', err.response)
        })
        await axios.get(`artkey/price/`)
        .then(response => {
            this.artKey = response.data.data.selling_price
        }).catch(() => {
            // console.log('Error Robot: ', err.response)
        })
        await axios.get(`investor/robot/${this.$route.params.id}/brokerchoice`)
        .then(response => {
            // console.log('Robot Broker: ', response.data.data)
            this.brokers = response.data.data
        }).catch(() => {
            // console.log('Error broker: ', err.response)
        })
        await axios.get(`investor/${localStorage.user_id}/pendingorder/`)
        .then(response => {
            var list = response.data.data
            for (let i = 0; i < list.length; i++) {
                if (list[i].product_id == this.$route.params.id) {
                    this.order = list[i]
                    // console.log('This Pending Order: ', this.order)
                }
            }
            
        }).catch(() => {
            // console.log('Error Pending Order: ', err.response)
        })
        
    },
    methods: {
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        brokerdetail(data){
            this.brokerdata = data
        },
        clickmodal(){
            this.loading = false
            this.submitted = false
        },
        submitmodal(){
            this.loading = true
        },
        sendBroker(broker){
            // localStorage.setItem('transaction_id', this.order.id)
            this.brokerId = broker.id
            // console.log(broker);
            this.brokerEndPoint = broker.configurations.filter(x=>x.name == 'PORTAL' && (x.endpoint != '' || x.endpoint != null || x.endpoint != undefined))
            // console.log(this.brokerEndPoint);
            this.brokerName = broker.name
            this.brokerImage = broker.logo
            // console.log('Broker: ', this.brokerId)
        },
        showPassword() {
            const input = document.querySelector('.field-password')
            const show = document.querySelector('.eye-icon')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        completeBroker(){
            $('#chooseBroker').modal('hide')
            $('#detailBroker').modal('show')
        },
        handleProduct(){

            this.handleDepositAmount()

            const vm = this
            this.loading = true
            this.message = ''
            this.msg = ''
            let data = new FormData()
            data.append('investor_id', this.user_id)
            data.append('broker_choice', this.brokerId)
            data.append('account_number', this.account_number)
            data.append('trader_password', this.trader_password)
            data.append('broker_server', this.broker_server)
            
            // data.append('broker_account_id', this.brokerId)
            data.append('product_id', this.robot.id)
            data.append('product_type', 'ROBOT')

            function updateDepositAmount(){
                let depo = new FormData()
                depo.append('deposit_amount', vm.deposit_amount)
                return axios.put(`investor/transaction/${localStorage.transaction_id}/`, depo)
            }
            
            this.$v.$touch();
            this.loading = true
            if (!this.$v.$invalid && this.loading) {
            this.submitted = true
                updateDepositAmount().then(()=>{
                    // console.log(response);
                        this.loading = true
                       const orderId = localStorage.getItem('transaction_id')
                        axios.put(`investor/transaction/${orderId}/broker-choice/`, data)
                        // axios.put(`transaction/${orderId}/broker-choice/`, data)
                        .then(() => {
                            // console.log(response);
                            $('#detailBroker').modal('hide')
                            // window.open('https://bithouse.id', '_blank')
                            vm.$router.push(`detail/${vm.brokerId}`)
                        }).catch((err) => {
                            // console.log(err.response);
                            vm.loading = false
                            vm.submitted = false
                            vm.message = err.data
                            // swal('Oppss!!!', err.response.statusText, 'warning', {
                            //     button: "OK"
                            // })
                        })

                }).catch(err => {
                    vm.msg = err.data || err.response.data
                    vm.loading = false
                    vm.submitted = false
                })
            }else{
                    this.submitted = false
                    this.loading = false
            }
            this.$validator.validateAll().then(isValid => {
                vm.submitted = true
                vm.loading = true
                if(isValid){
                    updateDepositAmount().then(()=>{
                        vm.submitted = true
                        vm.loading = true
                        const orderId = localStorage.getItem('transaction_id')
                        axios.put(`investor/transaction/${orderId}/broker-choice/`, data)
                        // axios.put(`transaction/${orderId}/broker-choice/`, data)
                        .then(() => {
                            // localStorage.setItem('activePair', this.local_active_pairs);
                            // localStorage.setItem('pairOption', this.local_pair_options);
                            // console.log(response);
                            $('#detailBroker').modal('hide')
                            // window.open('https://bithouse.id', '_blank')
                            vm.$router.push(`detail/${vm.brokerId}`)
                        }).catch((err) => {
                            // console.log(err.response);
                            vm.loading = false
                            vm.message = err.data
                            // swal('Oppss!!!', err.response.statusText, 'warning', {
                            //     button: "OK"
                            // })
                        })

                    }).catch(err => {
                        vm.msg = err.data || err.response.data
                        vm.loading = false
                    })
                    
                } else{
                    this.loading = false
                }
            })
        },
        handleBroker(){
            $('#chooseBroker').modal('hide')
            localStorage.setItem('transaction_id', this.order.id)
            this.$router.push(`detail/${this.brokerId}`)
        },
        handleDepositAmount(){
            if (this.order.investor_note != '') {
                
                const storedActivePair = localStorage.getItem('activePair');
                const storedPairOption = localStorage.getItem('pairOption');
    
                if (storedActivePair == 'MULTI') {
                    // Find the minimum deposit for the MULTI active pair
                    let multiPair = this.active_pairs.find(pair => pair.active_pair == 'MULTI');
                    if (multiPair) {
                        let minimumDeposit = multiPair.minimum_deposit;
                        // Compare the deposit_amount with the minimum_deposit
                        if (this.deposit_amount < minimumDeposit) {
                            throw this.alertErrorMessage(`Minimun deposit ${minimumDeposit}`, 'ok');
                        }
                    }
                }
                if (storedActivePair == 'DOUBLE') {
                    // Find the minimum deposit for the MULTI active pair
                    let multiPair = this.active_pairs.find(pair => pair.active_pair == 'DOUBLE');
                    if (multiPair) {
                        let minimumDeposit = multiPair.minimum_deposit;
                        // Compare the deposit_amount with the minimum_deposit
                        if (this.deposit_amount < minimumDeposit) {
                            throw this.alertErrorMessage(`Minimun deposit ${minimumDeposit}`, 'ok');
                        }
                    }
                }
                else {
                    
                    let pairOptionsDeposit = this.pair_options.find(pair => pair.symbol == `${storedPairOption}`);
    
                    if (pairOptionsDeposit) {
                        let minimumDeposit = pairOptionsDeposit.minimum_deposit;
                        // Compare the deposit_amount with the minimum_deposit
                        if (this.deposit_amount < minimumDeposit) {
                            throw this.alertErrorMessage(`Minimun deposit ${minimumDeposit}`, 'ok');
                        }
                    }
                }
                }
        },
        alertErrorMessage(message, textButton){
            swal('Minimum deposit are not reached!',`${message}`, 'error',{
                    button: {
                        textButton: `${textButton}`,
                    },
                    dangerMode: true,
                }).then(()=>{
                    this.loading = false
                    this.submitdata = false
                })
        },
    }
}
</script>
<style scoped>
.linkbroker{
    text-decoration: underline !important;
    text-align: center !important;
    background-color: transparent !important;
    font-size: 0.9rem;
    border: 0px !important;
    width: 100% !important;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    text-decoration: none !important;
    color: rgba(0, 0, 0, 0.6) !important;
    font-weight: 400;

}
.aliveimg{
    -webkit-filter: grayscale(0%) !important; /* Safari 6.0 - 9.0 */
  filter: grayscale(0%) !important;
}
.broker .broker-list .broker-img{
     -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.headdetailbroker figure{
    max-width: 70px;
    height: max-content;
}
.headdetailbroker figure img{
    width: 100%;
    height: 100%;
}
.headdetailbroker small{
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    font-size: 0.7rem !important;
}
.deskripsi-head{
    padding-left: 15px;
}
.deskripsi-head h5{
    margin-bottom: 0px !important;
    font-weight: 600;
}
.headdetailbroker p, .modalbroker p{
    margin-bottom: 0px !important;
    font-weight: 500;
    overflow: hidden !important;
}
.bottommodal{
    justify-content: space-between;
    display: flex;
}
.bottommodal > .btn_grey{
    padding: .375rem .75rem !important;
}
.bottommodal small{
    padding-top: 10px;
    font-weight: 600;
}
.small-if{
    text-align: center;
    display: block;
    color: rgba(0, 0, 0, 0.6);
}
</style>
<style>
.content-wrapper{
    background: transparent !important;
}
.card.available-robot__card{
    border-radius: 25px;
}
.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}
.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}
.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}
button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}
.myrobot-card__images {
    width: 190px;
    height: 178px;
    object-fit: cover;
    margin-bottom: 15px;
}

.broker .broker-list input[type='radio']{
    display: none;
}
.broker .broker-list input:checked ~ label.broker-body{
    border: 3px solid red !important;
}
.broker .broker-list input:checked ~ label.broker-body .check_img{
    display: block;
}
.broker .broker-list{
    text-decoration: none;
    color: var(--dark-grey);
}
.broker a.broker-list:hover > .broker-body{
    border: 3px solid var(--red);
}
.broker .broker-list .broker-body{
    border: 3px solid rgb(168, 168, 168) !important;
    background: white;
    padding: 10px;
    border-radius: 10px;
    transition: all 0.3s ease;
    width: 100%;
    height: 160px;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.1);
}
.broker .broker-list .broker-body .check_img{
    position: absolute;
    top: 0;
    right: 0;
    background: white;
    padding: 6px;
    border-radius: 0 10px 0 10px;
    display: none;
    z-index: 3;
    transition: all 0.3s ease;
}
.broker .broker-list .broker-body figure{
    width: 100%;
    height: 80px;
    margin-bottom: 5px;
}
.broker .broker-list .broker-body p{
    margin: 0;
    font-size: 11pt;
    max-height: 50px;
    overflow-y: scroll;
}

.broker .broker-list .broker-body p::-webkit-scrollbar {
    width: 4px;
}
.broker .broker-list .broker-body p::-webkit-scrollbar-track {
    box-shadow: inset 0 0 4px grey; 
    border-radius: 5px;
}
.broker .broker-list .broker-body p::-webkit-scrollbar-thumb {
    background: #c9c9c9; 
    border-radius: 5px;
}
.broker .broker-list .broker-body p::-webkit-scrollbar-thumb:hover {
    background: #797979; 
}

.broker .broker-list .broker-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0;
    border-radius: 5px;
}
</style>